import React from 'react';
import PropTypes from 'prop-types';
import { getWeekString } from 'day8-react/build/helpers/booking';

const WeekDate = ({ className = '', week }) => {
  return (
    <div className={className}>
      {getWeekString(week)}
    </div>
  );
};
WeekDate.propTypes = {
  week: PropTypes.number.isRequired,
  className: PropTypes.string
};
export default WeekDate;